const buildOptions = (options, engine, drivetrain, transmission, color) => {
  const reducedOptions = options.reduce((acc, cur) => {
    return `${acc}${acc.length ? '|' : ''}${cur.optionId}|${cur.isSelected}`
  }, '')

  return `${reducedOptions}${reducedOptions.length ? '|' : ''}${engine.engineId}|true|${drivetrain.drivetrainId}|true|${transmission.transmissionId}|true|${color}|true`
}
const encode = value => {
  // Convert value to string since it could be a number or boolean.
  return `${value || ''}`
    .replace(/\s/g, '-')
    .replace(/\//g, '-')
    .replace(/[^a-zA-Z0-9-_|]/g, '')
}

export const redirectToOwners = (year, make, model, style, trim, options, engine, drivetrain, transmission, color, mileage, condition, offerId, kbbUrl, lnxCode) => {
  const params = {
    year,
    make,
    model,
    style,
    vehicleId: trim,
    options: buildOptions(options, engine, drivetrain, transmission, color),
    mileage,
    intent: 'trade-in-sell',
    pricetype: 'cashoffer',
    condition,
    isCombined: true,
    lnx: lnxCode,
    ...(offerId ? { offerId } : {})
  }

  return `${kbbUrl}/vehicles/hub/pricingredirect/?${Object.keys(params)
    .map(param => `${param}=${encode(params[param])}`)
    .join('&')}`.toLowerCase()
}

export const formatPrice = price => {
  return `$${price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
}
